import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { Sales } from "../models/sales";
import { SalesService } from "../services/sales.service";

@Injectable()
export class SalesResolver implements Resolve<Sales> {
  constructor(private service: SalesService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Sales> {
    const id = Number(route.paramMap.get("id"));
    if (id != 0) {
      return this.service.getSalesById(+id);
    } else {
      return null;
    }
  }
}
